import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";
import { View, VStack } from "@gluestack-ui/themed";
import { DataTable } from "@repo/core/components/core/DataTable";
import { MustShow } from "@repo/core/components/core/MustShow";
import { Modal } from "@repo/core/components/layout/Modal";
import { ReportSelectFilters } from "@repo/core/components/layout/ReportSelectFilters";
import { ReportScreenHeader } from "../../components/ReportScreenHeader";
import { MonthlySalesReportController } from "./controller";
import { ReportCharts } from "@repo/core/components/chart/ReportCharts";
import { getReportCardByReportType } from "../../components/ReportCard/utils";
import {
  ChartVisualizationData,
  LineValueData
} from "@repo/core/components/chart/ReportCharts/types";
import { ReportCardEnum, ReportTypeEnum } from "@repo/core/types/reports";
import { EmptyState } from "@repo/core/components/layout/EmptyState";
import Spinner from "@repo/core/components/core/Spinner";
const MonthlySalesReport = () => {
  const {
    isMobile,
    onChangeStartDate,
    onChangeEndDate,
    table,
    rightLabelsTransform,
    cardsData,
    handleExportTable,
    filterModalRef,
    topRightText,
    reportTypes,
    selectedReportType,
    onSelectReportType,
    filterStartDate,
    filterEndDate,
    chartBarData,
    chartLineData,
    handleSelectFilters,
    isFetchingMonthlySalesReports,
    hasReportData
  } = MonthlySalesReportController();
  return (
    <Scaffolds.Root showHeader={false}>
      <Scaffolds.StoreSelect
        showHeader={false}
        statusBarVariant={StatusBarVariantEnum.GREEN}
        storeSelectorVariant={StoreSelectorVariantEnum.SHOPKEEPER}
        topRightText={topRightText}
        topRightIcon="refresh"
      >
        <Scaffolds.Page
          showHeader
          pt={!isMobile ? "$3" : "$0"}
          title="Vendas Mensais"
          p="$0"
          bg="$backgroundLight0"
          rightIcon={isMobile ? undefined : "file-export"}
          rightIconSize={20}
          rightWebLabel={isMobile ? undefined : "Exportar"}
          onPressRightIcon={isMobile ? undefined : handleExportTable}
        >
          <VStack flex={1} px={isMobile ? 0 : "$4"} gap={isMobile ? 0 : "$6"}>
            <ReportScreenHeader
              filterModalRef={filterModalRef}
              defaultStartDate={filterStartDate}
              defaultEndDate={filterEndDate}
              onChangeStartDate={onChangeStartDate}
              onChangeEndDate={onChangeEndDate}
              handleSelectFilter={handleSelectFilters}
              reportTypes={reportTypes}
              selectedReportType={selectedReportType as ReportTypeEnum}
              onSelectReportType={onSelectReportType}
            />

            <MustShow
              isVisible={!isFetchingMonthlySalesReports && hasReportData}
              fallback={
                <MustShow
                  isVisible={isFetchingMonthlySalesReports}
                  fallback={
                    <EmptyState
                      flex={1}
                      text="Nenhum relatório disponível para o período selecionado."
                    />
                  }
                >
                  <VStack flex={1} alignItems="center" justifyContent="center">
                    <Spinner size={60} />
                  </VStack>
                </MustShow>
              }
            >
              <ReportCharts.Bar
                isStackedBars
                data={chartBarData?.data as ChartVisualizationData[]}
                lineData={chartLineData?.data as LineValueData}
                maxValue={1000}
                maxDomain={800}
                numberOfGridLines={10}
                leftLabelsTransform={(value) => `R$${value / 10}M`}
                rightLabelsTransform={rightLabelsTransform}
                showRightLabels
              />

              <MustShow isVisible={!isMobile}>
                <DataTable table={table} />
              </MustShow>

              <MustShow isVisible={isMobile}>
                <VStack>
                  {cardsData?.map((card) =>
                    getReportCardByReportType(
                      ReportCardEnum.MONTHLY_TRANSACTIONS,
                      card
                    )
                  )}
                </VStack>
              </MustShow>
            </MustShow>
          </VStack>
        </Scaffolds.Page>
      </Scaffolds.StoreSelect>

      <Modal ref={filterModalRef}>
        <View flex={1} p="$2" bg="$backgroundLight0">
          <ReportSelectFilters
            onClose={() => filterModalRef.current?.close()}
          />
        </View>
      </Modal>
    </Scaffolds.Root>
  );
};
export default MonthlySalesReport;
